import { useIssApi } from "@bfc-software/bfc-web-ui/lib/iss-api-client";

import type { QueryLike } from "@bfc-software/bfc-web-ui/lib/async-utils";

/** One zone as the filter offers it. `id` is the `zone_ext_id` (`ZoneCatalog.id`)
 *  as an opaque string; `toWireExtIds` makes it a number at the wire (§9.2). */
export interface ZoneOption {
  id: string;
  label: string;
}

/**
 * The zone filter's option list: the item service's whole zone catalog for
 * this warehouse, read once on page load and treated as a constant.
 *
 * `/zones/all` takes no params - it is scoped server-side by the token, the
 * same reason `zones.tsx:469` calls it bare - so there is no `orgId`/
 * `warehouseId` to plumb in and no `enabled` gate to wait on.
 */
export function useZoneCatalog(): QueryLike<ZoneOption[]> {
  const client = useIssApi();

  return client.useQuery(
    "get",
    "/zones/all",
    {},
    {
      // An envelope, not an array: `ZoneCatalogAllEnvelope` (iss.ts:1259-1262)
      // wraps the rows in `data`, the same shape `zones.tsx:479` reads.
      select: (envelope) =>
        envelope.data
          .map((zone) => ({ id: String(zone.id), label: zone.name }))
          .sort((a, b) => a.label.localeCompare(b.label)),
    },
  );
}
